<div class="ft-form">
    <div class="ft-form-row overflow-hidden bg-light mt-0 pl-2">
        <!-- LEFT: Report -->
        <div class="flex-grow-1 pl-2" style="min-height:0; overflow:hidden;">
            <app-chat-report-display />
        </div>

        <!-- RIGHT: AI Assistant -->
        <app-chat-sidebar [isCollapsed]="isCollapsed" [isMobileOpen]="isMobileOpen"
            [isSmallScreen]="isSmallScreen" (togglePanel)="togglePanel()" />

        <!-- Mobile open button -->
        @if (isSmallScreen && !isMobileOpen) {
            <button type="button" class="btn btn-success rounded-circle ai-mobile-btn" (click)="openMobile()"
                aria-label="Open AI assistant">
                <i class="fa fa-comments"></i>
            </button>
        }

        <!-- Mobile backdrop -->
        @if (isSmallScreen && isMobileOpen) {
            <div class="ai-backdrop" (click)="closeMobile()"></div>
        }
    </div>
    <div class="footer">
        <button class="ft-btn ft-btn-active-not-selected" (click)="cancel()">{{"lbl_cancel" | translate}}</button>
    </div>
</div>
